import type { CreateAxiosDefaults } from 'axios'
import axios from 'axios'
import { toSnakecase } from '@/utilities/transformAxiosRequest.ts'
import { toCamelcase } from '@/utilities/transformAxiosResponse.ts'
import { env } from '@/utilities/env.ts'

export function createAxiosInstance(config: CreateAxiosDefaults = {}) {
  return axios.create({
    baseURL: env('VITE_API_BASE_URL'),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    timeout: 5 * 60 * 1000,
    transformRequest: [toSnakecase],
    transformResponse: [toCamelcase],
    ...config,
  })
}
